import {WalletPlatform} from '@/enums/WalletPlatform'
import {BadInvocationRequest} from '@/model/wallets/types/WalletErrors'
import {isMetaMaskProvider} from '../connection/MetaMaskConnection'
import {WalletProviderStrategy} from './WalletProviderStrategy'

export class MetaMaskProvider implements WalletProviderStrategy {
  platform = WalletPlatform.METAMASK
  nep21Name = 'MetaMask'

  getAddress(provider: any) {
    return isMetaMaskProvider(provider) ? provider.address : null
  }

  async invoke(provider: any, payload: any) {
    if (!isMetaMaskProvider(provider)) throw BadInvocationRequest

    const txHash = await provider.provider.request({
      method: 'eth_sendTransaction',
      params: [payload],
    })

    if (typeof txHash !== 'string' || !txHash) throw BadInvocationRequest

    return txHash
  }
}
